import React from "react";
import { Row } from "reactstrap";

export const ModalProgressBar = ({
    CurrentView,
    setCurrentView,
    check_status
}) => {
    // let className = "grey-border";
    let placement_class = [];
    let placement_test_bar = [];
    let bordercolor = []; 
    let classNamePlacement =[];
    let text_color = [];

  

    for(var i=1; i<=4; i++)
    {
        if (check_status.includes(i)) {
            // className = "success-border";
            placement_class[i] = "completed-page";
            placement_test_bar[i] = "line-bar-active";
            text_color[i] = "text-dark";
            bordercolor[i] = "true";
        }
        if( CurrentView === i )
        {
          if (bordercolor[i] === "true"){
             classNamePlacement[i] = "completed-border";
          }
          else{
             classNamePlacement[i] = "uncompleted-border";
          }
           placement_class[i] ="current-page";
           placement_test_bar[i] ="bg-current";
           text_color[i] = "text-success";
        }
    } 
  return (
    <>
      <Row className="bg-white  border-top-0 border-bottom-0 px-4 pb-3">
        <div className="progress-bar-container">
          <ul class="order-list-container ">
            <li class={`not-started-page ${classNamePlacement[1]} ${placement_class[1]}` }>
                <span class={`bg-completed btn ${placement_test_bar[1]}`}  onClick={() => setCurrentView(1)}>
                1 
                </span>
                <div class={`progress-bar-heading text-nowrap f-13  ${text_color[1]}`}>Introduction</div>
            </li>
            <li class={`not-started-page ${classNamePlacement[2]} ${placement_class[2]}` }>
                <span class={`bg-completed btn ${placement_test_bar[2]}`}  onClick={() => setCurrentView(2)}>
                2
                </span>
                <div class={`progress-bar-heading f-13  text-nowrap ${text_color[2]}`}>System</div>
            </li>
            <li class={`not-started-page ${classNamePlacement[3]} ${placement_class[3]}` }>
                <span class={`bg-completed btn ${placement_test_bar[3]}`}  onClick={() => setCurrentView(3)}>
                3
                </span>
                <div class={`progress-bar-heading f-13  text-nowrap ${text_color[3]}`}>Tips</div>
            </li>
            <li class={`not-started-page ${classNamePlacement[4]} ${placement_class[4]}` }>
                <span class={`bg-completed btn ${placement_test_bar[4]}`}  onClick={() => setCurrentView(4)}>
                4
                </span>
                <div class={`progress-bar-heading f-13 text-nowrap ${text_color[4]}`}>Confirmation</div>
            </li>
          </ul>
        </div>
      </Row>
    </>
  );
};
